export const selectExtensionMessage = (state) => state.messages;
